import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const trackEvent = async (event, metadata = {}) => {
  try {
    await api.post("/track", { event, metadata });
  } catch (e) {
    // fire-and-forget
  }
};

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const uploadBill = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/leads/upload-bill", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const getUtilityRates = () => api.get("/content/utility-rates").then((r) => r.data);
export const getWhySolarNow = () => api.get("/content/why-solar-now").then((r) => r.data);
